const pad = (value) => String(value).padStart(2, "0");

export const toEnquiryFormDate = (value) => {
    if (!value) return "";
    const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
    if (dateOnlyMatch) return `${dateOnlyMatch[3]}/${dateOnlyMatch[2]}/${dateOnlyMatch[1]}`;
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};

export const toEnquiryDateOnly = (value) => {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(value || "").trim());
    if (!match) return null;
    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day, 12));
    if (
        date.getUTCFullYear() !== year
        || date.getUTCMonth() + 1 !== month
        || date.getUTCDate() !== day
    ) return null;
    return `${year}-${pad(month)}-${pad(day)}`;
};
